export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}

export function toDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => resolve(e.target?.result as string);
    reader.onerror = (error) => reject(error);
  });
}

// Cache-bust a stored PDF's URL with its version so a regenerated file shows
// up. Presigned S3 URLs are left alone: they already change on every API
// response, and an extra query parameter would invalidate their signature.
export function pdfPreviewUrl(pdfUrl: string, version: string): string {
  // SigV4 (X-Amz-Signature) and SigV2 (Signature) presigned URLs.
  if (/[?&](X-Amz-Signature|Signature)=/.test(pdfUrl)) return pdfUrl;
  const sep = pdfUrl.includes("?") ? "&" : "?";
  return `${pdfUrl}${sep}v=${encodeURIComponent(version)}`;
}
